import React , { Component } from 'react';

import Agent from "../../Network/Agent";
import {ActionResponseEnum} from "../../Network/Enum/ActionResponseEnum";
import ToolBar from "../../Components/Elements/ToolBar";
import InputPrimary from "../../Components/Elements/InputPrimary";
import ButtonPrimary from "../../Components/Elements/ButtonPrimary";

class AuthName extends Component {
    constructor(props) {
        super(props);
        this.state = {
            buttonLoading : false
        }
    }
    submitName = (e) => {
        e.preventDefault()
        this.setState({
            buttonLoading : true
        })
        let firstName = document.getElementById('user_first_name').value
        let lastName = document.getElementById('user_last_name').value
        Agent.Auth.updateName(lastName , firstName)
            .then(response => {
                if (response.data.action === ActionResponseEnum.REDIRECT) {
                    window.location = response.data.next
                }
            })
            .catch(error => {
                console.log(error.response)
            })
    }

    componentDidMount() {
    }

    render() {
        return(
            <>
                <ToolBar title={'نام و نام خانوادگی'} url={""} arrowDisplay={"d-none"} />
                <section className=''>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12'>
                                <div className='mobile-subtitle-regular cl-subtitle mt-8'>
                                    لطفا نام و نام خانوادگی خود را وارد کنید
                                </div>
                            </div>
                            <div className='col-12'>
                                <form id='form_send_name' onSubmit={this.submitName}>
                                    <div className='mt-32'>
                                        <InputPrimary
                                            name='user_first_name'
                                            id='user_first_name'
                                            type='text'
                                            placeHolder='مثال : بهنام ...' />
                                    </div>
                                    <div className='mt-16'>
                                        <InputPrimary
                                            name='user_last_name'
                                            id='user_last_name'
                                            type='text'
                                            placeHolder='مثال : حسن نیا ...' />
                                    </div>
                                    <div className='mt-32'>
                                        <ButtonPrimary mode='dark-mode' text='ثبت' isLoading={this.state.buttonLoading} />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        )
    }
}

export default AuthName